export default "__VITE_ASSET__QT1i7u$x__"